import { StaffApis } from "common/apis/staff";
import { FileUtils } from "components/Utils/file";
import _ from "lodash";

export namespace FileService {
    export const tryUploadFiles = async (files: any[]) => {
        const uploadedFiles = [];
        if (_.isNil(files)) {
            return uploadedFiles;
        }
        for await (const file of files) {
            console.log("[tryUploadFiles] file", file);
            if (_.isEmpty(file)) {
                continue;
            }
            const uploadedFile = await tryUploadFile(file);
            uploadedFiles.push(uploadedFile);
        }
        return uploadedFiles;
    }

    export const tryUploadFile = async (file: any) => {
        console.log("[tryUploadFile] file", file);
        if (_.isEmpty(file)) {
            return null;
        }
        let url = file.url;
        let path = file.path;
        if (_.isNil(url) || _.isNil(path)) {
            const uploadUrl = await StaffApis.getS3UploadUrl(file);
            console.log("[tryUploadFile] uploadUrl", uploadUrl);
            const uploadedUrl = await FileUtils.uploadS3File(file, uploadUrl);
            console.log("[tryUploadFile] uploadedUrl", uploadedUrl);
            const urlObj = new URL(uploadedUrl);
            url = uploadedUrl;
            path = urlObj.pathname;
        }
        const uploadedFile = {
            url,
            path,
            name: file.name,
            type: file.type,
            size: file.size,
            hash: file.hash
        }
        return uploadedFile;
    }
}